import React from 'react';
import PlayBackground from '../../svgs/components/play_background.js';
import PlayTriangle from '../../svgs/components/play_triangle.js';
import { clickable } from '../../helpers/mouseCursorPosition.js';
export const VideoPlayButton = ({ size = 60 }) => (React.createElement(clickable.div, { style: {
        cursor: 'pointer',
    }, className: "play-button" },
    React.createElement("i", { key: "play-triangle", "data-hook": "play-triangle", className: 'gallery-item-video-play-triangle play-triangle ' },
        React.createElement(PlayTriangle, { size: size })),
    React.createElement("i", { key: "play-bg", "data-hook": "play-background", className: 'gallery-item-video-play-background play-background ' },
        React.createElement(PlayBackground, { size: size }))));
export default VideoPlayButton;
//# sourceMappingURL=playButton.js.map